import { useEffect, useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";

type props = {
  columns: any;
  rows: any;
  columnVisibilityModel?: any;
  setSelectedRow?: any;
  gridApi?: any;
  renderPagination?: any;
  onClickedOnHeaderCheckbox?: (data: any) => void;
};

export default function TableComponent({
  rows,
  columns,
  columnVisibilityModel,
  setSelectedRow,
  gridApi,
  renderPagination,
  onClickedOnHeaderCheckbox,
}: props) {
  // const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
  //   items: [
  //     {
  //       id:1,field:'availableWeight', value:"29",operator:"contains",
  //     },
  //     {
  //       id: 2,
  //       field: 'role',
  //       value: searchValue,
  //       operator: 'contains',
  //     },
  //   ],
  //   logicOperator: GridLogicOperator.And,
  // });

  // useEffect(()=>{
  //   setFilterModel((prevData:any)=>{
  //    return ({
  //       items:[
  //         {
  //         id:2,field:'role',value:searchValue,operator:'contains',
  //       },
  //     ],
  //     logicOperator: GridLogicOperator.And,
  //     })
  //   })
  // },[searchValue])
  // const handleSearch = (value: string) => {
  //   setSearchValue(value);
  // };
  // useEffect(()=>{
  //
  //   if(rows)
  //   setSelectedRow((prevData:any)=>{
  //     return {...prevData,row:rows}
  //    })
  // },[rows])
  useEffect(() => {
    if (gridApi?.current) {
      const data2 = gridApi?.current?.getVisibleColumns();
      setSelectedRow((prevData: any) => {
        return { ...prevData, column: data2?.slice(1, data2?.length) };
      });
      // setSelectedRow((prevData:any)=>{
      //  return {...prevData,column:data2?.slice(1,data2?.length-1)}
      // })
    }
  }, [columnVisibilityModel]);
  const prevSelectionRef = useRef<number>(0);

  return (
    <>
      {/* <Button onClick={()=>{
    setColumnVisibilityModel((prevData:any)=>({name:!prevData.name}))}}>TESTER</Button> */}
      {/* <Button onClick={()=>gridApi.current.exportDataAsCsv()}>TESTER</Button>
    <Button onClick={()=>gridApi.current.exportDataAsPrint()}>TESTER</Button>
    <Button onClick={()=>{
      
      const data=gridApi.current.getSelectedRows()
  
      // downloadPdf();
      }}>TESTER</Button> */}
      {/* <Button onClick={()=>{

const downloadExcel = () => {
  const newData = rows.map((row:any) => {
    delete row.tableData
    delete row.id
    delete row.image
    return row
  })
  const workSheet = XLSX.utils.json_to_sheet(newData)
  const workBook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workBook, workSheet, "students")
  //Buffer
  XLSX.write(workBook, { bookType: "xlsx", type: "buffer" })
  //Binary string
  XLSX.write(workBook, { bookType: "xlsx", type: "binary" })
  //Download
  XLSX.writeFile(workBook, "StudentsData.xlsx")


}
downloadExcel();
    }}>TESTER</Button> */}

      <DataGrid
        apiRef={gridApi}
        rows={rows}
        columns={columns}
        hideFooter={renderPagination}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        getRowId={(item) => item?.id || item?._id}
        onRowSelectionModelChange={(newSelection) => {
          if (!gridApi.current) return;

          const prevCount = prevSelectionRef.current;
          const newCount = newSelection.length;

          const diff = newCount - prevCount;

          // 🔥 Detect Select All (header checkbox)
          const clickedHeaderCheckboxDiff = diff > 1;

          onClickedOnHeaderCheckbox?.(clickedHeaderCheckboxDiff);

          // Save for next comparison
          prevSelectionRef.current = newCount;

          // ---- Store Selected Rows -----
          let temp = [];
          const data = gridApi.current.getSelectedRows();
          for (let [key] of data) {
            temp.push(rows.find((r: any) => r.id === key));
          }

          setSelectedRow((prev: any) => ({ ...prev, row: temp }));
        }}
        // filterModel={filterModel}
        // onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}

        columnVisibilityModel={columnVisibilityModel}
        // onColumnVisibilityModelChange={(newModel) =>
        //   setColumnVisibilityModel(newModel)
        // }
        // slots={{
        //   toolbar: GridToolbar,
        // }}
        pageSizeOptions={[5]}
        checkboxSelection
        disableRowSelectionOnClick
        // slotProps={{
        //   toolbar: {
        //     showQuickFilter: true,
        //     quickFilterProps: { debounceMs: 500 },
        //     value: searchValue||"",
        //     clearSearch: () => handleSearch(""),
        //     onChange: (event: ChangeEvent<HTMLInputElement>) =>
        //       handleSearch(event.target.value),
        //   },
        // }}
        sx={{
          ".MuiDataGrid-iconButtonContainer": {
            width: "auto",
            visibility: "visible",
          },
          ".MuiDataGrid-sortIcon": {
            opacity: "inherit !important",
          },
          ".MuiDataGrid-virtualScroller": {
            height: rows.length ? "100%" : "50px",
          },
        }}
        rowHeight={70}
      />
      {renderPagination}
    </>
  );
}
